module.exports = __webpack_public_path__ + "img/jameson-5-text.27a88bbf.png";